// extracted by mini-css-extract-plugin
export default {"cursos":"Cursos_cursos__9rkyB"};